import React, {FunctionComponent} from 'react';
import cn from 'classnames';

import {UpdateState} from 'enums';
import './StateBar.scss';

interface IStateBarProps {
    className?: string
    state: UpdateState,
}

const stateClasses = {
    [UpdateState.Draft]: 'draft',
    [UpdateState.AwaitApproval]: 'awaitApproval',
    [UpdateState.Scheduled]: 'scheduled',
    [UpdateState.Running]: 'running',
    [UpdateState.Canceled]: 'canceled',
    [UpdateState.Error]: 'error',
    [UpdateState.Done]: 'done',
}

export const StateBar: FunctionComponent<IStateBarProps> = function StateBar(props) {
    const { className, state } = props;

    return (
        <div className={cn("stateBar", className, stateClasses[state])}>
            {/* Show animated boxes when running */}
            {state === UpdateState.Running && (<>
                <div className="stateBar_runningBox box1"></div>
                <div className="stateBar_runningBox box2"></div>
                <div className="stateBar_runningBox box3"></div>
            </>)}
        </div>
    )
};